export default "__VITE_ASSET__d570c063__"